import { types } from 'mobx-state-tree';
import { Line } from 'models/types';

export const AuditDetail = types.model({
  line: types.array(Line),
});
